import { number, object, string } from "yup";
import { useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "../../../commons/helpers";
import Strings from "../../../constants/strings";
import TopicService from "../../../services/message/Topic.service";

import { ITopicError } from "./useData";
import { Mode } from "../../../constants/enums";
import { ITopic } from "../../../commons/interfaces";


const VALID_TOPIC_NAME = new RegExp(/^[a-zA-Z0-9\-_\.~%]+$/);
const schemaObject = object({
    type: number().required(),
    // categoryId: string().required(),
    topicName: string().test(
        "topic-name-validation",
        Strings.Validation.TOPIC_NAME,
        (topicName) => VALID_TOPIC_NAME.test(topicName)
    ).required(),
    description: string().required(),
});

const useSubmit = ({
    data,
    mode,
    setError,
    onGoBack,
    onChangeMode,
}: {
    mode: Mode;
    data: ITopic;
    onGoBack: () => void;
    onChangeMode: (mode: Mode) => void;
    setError: React.Dispatch<React.SetStateAction<ITopicError>>;
}) => {
    const {
        language,
        clientId,
        userInfo,
        tenantCode,
        serviceCode,
        organizationId,
        onError = () => { },
        onSuccess = () => { },
        onShowLoading = () => { },
        onHideLoading = () => { },
    } = useCommonComponentContext();


    const onSubmit = async () => {
        if (mode === Mode.View) return onChangeMode(Mode.Update);

        try {
            onShowLoading();
            await schemaObject.validate(data, { abortEarly: false });
            const requestData = {
                id: data?.id || undefined,
                topicName: data?.topicName,
                description: data?.description,
                type: data?.type,
                categoryId: data?.categoryId,
                clientId: data?.clientId || clientId,
                serviceCode,
                tenantCode,
                organizationId: data?.organizationId || organizationId || "0",
            };
            if (!Helpers.isNullOrEmpty(requestData?.id)) {
                await TopicService.update(requestData);
                onSuccess(Strings.TOPIC.UPDATE_SUCCESS);
            } else {
                await TopicService.create(requestData);
                onSuccess(Strings.TOPIC.CREATE_SUCCESS);
            }
            onGoBack();
        } catch (error: any) {
            if (error.name === "ValidationError") {
                setError(Helpers.handleValidationError(error) as ITopicError);
                return;
            }
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };
    return { onSubmit };
};

export default useSubmit;
